'use client';

import { ButtonVariants } from '@pixum/button';
import { useCheckoutOrder } from '../../hooks/checkout';
import { ProceedButton } from '../../partials/ProceedButtonStream/ProceedButton';
import type { CheckoutOrderButtonProps } from '../types';

export function CheckoutOrderButton({
  isDataPrivacyRequired,
  constants,
  paymentMethod,
  errorRoute,
  ariaLabel,
  children
}: CheckoutOrderButtonProps) {
  const { isBusy, handleOrderClick } = useCheckoutOrder({ isDataPrivacyRequired, constants, paymentMethod, errorRoute });

  return (
    <ProceedButton
      variant={ButtonVariants.STRONG}
      isBusy={isBusy}
      isClickable={!isBusy}
      ariaLabel={ariaLabel}
      onClick={handleOrderClick}
    >
      {children}
    </ProceedButton>
  );
}
